// @ts-nocheck
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import CheckinSummaryPublicView from '@/components/checkin/CheckinSummaryPublicView';

/**
 * Staff-authenticated check-in grid. Opened from the Staff Portal event rows.
 * No token needed — signed-in staff with check-in access edit directly (RLS via RPC).
 */
const StaffCheckinSheetPage: React.FC = () => {
  const [params] = useSearchParams();
  const eventId = params.get('event') || undefined;

  if (!eventId) {
    return (
      <div className="flex items-center justify-center py-20 text-muted-foreground">
        No event specified.
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <CheckinSummaryPublicView eventId={eventId} label="Check-In Sheet" />
    </div>
  );
};

export default StaffCheckinSheetPage;
